// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import routes from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './utils/rem'
import './assets/style/common.scss'
import 'vue-social-share/dist/client.css';
import echarts from 'echarts'
import store1 from './CancelToken'

import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.min.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'
import '../static/iconfont/iconfont.css'
import 'vue-social-share/dist/client.css';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        count: 0
    },
    mutations: {
        increment (state) {
            state.count++
        }
    }
})
store.commit('increment')

console.log(store.state.count) // -> 1
window.eventBus = new Vue()
Vue.prototype.$echarts = echarts
Vue.use(Element);
Vue.use(VueRouter);

window.eventBus = new Vue()
window.title = 'SEO_网站优化_整站优化_百度快速排名软件_关键词排名查询工具_爱排名网络营销推广平台'
const router = new VueRouter({
  mode: 'history',
  routes
})

Vue.config.productionTip = false



router.beforeEach((to, from, next) => {
    // document.title = '恨排名'
    // const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    //
    // const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    //
    // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    //
    // console.log(previousNearestWithMeta);
    //
    // //if(nearestWithTitle) document.title = nearestWithTitle.meta.title;
    //
    // Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
    //
    // if(!nearestWithMeta) return next();
    //
    // nearestWithMeta.meta.metaTags.map(tagDef => {
    //
    //     const tag = document.createElement('meta');
    //
    //     Object.keys(tagDef).forEach(key => {
    //         alert(key)
    //         tag.setAttribute(key, tagDef[key]);
    //     });
    //
    //     tag.setAttribute('data-vue-router-controlled', '');
    //
    //     return tag;
    // }).forEach(tag => document.head.appendChild(tag));
  store1._axiosPromiseCancel.forEach(e => {
    e && e()
  })
    store1._axiosPromiseCancel = []


    next();

    next()
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store:store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js